import { union } from "utils/Utils";
import { FetchOrganizationListEndAction } from "../actions/FetchOrganizationList";
import { OrgState } from "../state";

export function fetchOrganizationList(state: OrgState, action: FetchOrganizationListEndAction) {
    const { error, organizations, lastEvaluatedKey } = action.payload;
    const newState: Partial<OrgState> = { error, orgPages: state.orgPages.slice(), orgs: state.orgs ? state.orgs.slice() : undefined };

    if (organizations) {
        newState.orgs = union(newState.orgs, organizations, "organizationId").sort((a, b) => {
            const orgA = a.name.toLowerCase();
            const orgB = b.name.toLowerCase();

            if (orgA < orgB) {
                return -1;
            }

            if (orgA > orgB) {
                return 1;
            }

            // names must be equal
            return 0;
        });

        newState.orgPages.push({ organizations, lastEvaluatedKey });
    }

    return { ...state, ...newState, loading: false };
}
